var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _vm._l(_vm.loopbaanFiches, function(lbf, index) {
          return [
            _c(
              "div",
              { key: "lbf-list-" + index },
              [
                _vm._l(_vm.tew.loopbaanFiches, function(tewFile, index) {
                  return _c("list-item-file", {
                    key: "tew-file-" + index,
                    attrs: {
                      icon: "file-alt",
                      file: tewFile,
                      title: "Loopbaanfiche " + (index + 1)
                    }
                  })
                })
              ],
              2
            )
          ]
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }